import { BitcoinCircle, EthCircle, MUsdCircle02, Cryptocurrency04, } from "@mezo-org/mezo-clay";
import { convertToUsd, formatUsd } from "./currency";
import { fromFixedPointToString } from "./numbers";
// TODO: Add actual icons for the assets
const CRYPTO_ASSETS = {
    BTC: {
        name: "Bitcoin",
        symbol: "BTC",
        icon: BitcoinCircle,
        decimals: 18,
    },
    ETH: {
        name: "Ethereum",
        symbol: "ETH",
        icon: EthCircle,
        decimals: 18,
    },
    MUSD: {
        name: "MUSD",
        symbol: "MUSD",
        icon: MUsdCircle02,
        decimals: 18,
    },
    mDAI: {
        name: "mDAI",
        symbol: "mDAI",
        icon: Cryptocurrency04,
        decimals: 18,
    },
    mFBTC: {
        name: "mFBTC",
        symbol: "mFBTC",
        icon: BitcoinCircle,
        decimals: 8,
    },
    mcbBTC: {
        name: "mcbBTC",
        symbol: "mcbBTC",
        icon: BitcoinCircle,
        decimals: 8,
    },
    mSolvBTC: {
        name: "mSolvBTC",
        symbol: "mSolvBTC",
        icon: BitcoinCircle,
        decimals: 18,
    },
    mswBTC: {
        name: "mswBTC",
        symbol: "mswBTC",
        icon: BitcoinCircle,
        decimals: 8,
    },
    mT: {
        name: "mT",
        symbol: "mT",
        icon: Cryptocurrency04,
        decimals: 18,
    },
    mUSDC: {
        name: "mUSDC",
        symbol: "mUSDC",
        icon: Cryptocurrency04,
        decimals: 6,
    },
    mUSDe: {
        name: "mUSDe",
        symbol: "mUSDe",
        icon: Cryptocurrency04,
        decimals: 18,
    },
    mUSDT: {
        name: "mUSDT",
        symbol: "mUSDT",
        icon: Cryptocurrency04,
        decimals: 6,
    },
    mxSolvBTC: {
        name: "mxSolvBTC",
        symbol: "mxSolvBTC",
        icon: BitcoinCircle,
        decimals: 18,
    },
};
/**
 * Gets details of given crypto asset
 * @param key The key of crypto asset
 * @returns The crypto asset details
 */
export function getCryptoAsset(key) {
    return CRYPTO_ASSETS[key];
}
/**
 * Checks if given crypto asset is Bitcoin-like
 * @param key The key of crypto asset
 * @returns True if crypto asset is Bitcoin-like
 */
export function isBitcoinLikeCryptoAsset(key) {
    return /(btc)/i.test(key);
}
/**
 * Checks if given crypto asset is USD-like
 * @param key The key of crypto asset
 * @returns True if crypto asset is USD-like
 */
export function isUsdLikeCryptoAsset(key) {
    return /(usd|dai)/i.test(key);
}
/**
 * Formats crypto asset to balance details (balance in USD and decimals)
 * @param type The type of crypto asset
 * @param balance The balance of crypto asset
 * @param usdConversionRate The USD conversion rate
 * @returns The balance details
 */
export function mapCryptoAssetToDetails(type, balance, usdConversionRate, usdConversionRateDecimals) {
    const { decimals } = getCryptoAsset(type);
    const formattedBalance = fromFixedPointToString(balance, decimals, isUsdLikeCryptoAsset(type) ? 2 : 4);
    const usdBalance = convertToUsd(balance, decimals, usdConversionRate, usdConversionRateDecimals);
    const formattedUsdBalance = formatUsd(usdBalance);
    return {
        type,
        rawBalance: balance,
        formattedBalance,
        usdBalance,
        formattedUsdBalance,
    };
}
//# sourceMappingURL=cryptoAssets.js.map